export type InvoiceEditorSectionId = 'details' | 'items' | 'payment'

export type InvoiceEditorChecklistItem = {
  id: 'title' | 'contents' | 'schedule'
  /** Left-column card the row focuses when the check is not satisfied. */
  section?: InvoiceEditorSectionId
  label: string
  satisfied: boolean
}

function pluralize(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`
}

/**
 * "Before you save" checklist shown in the invoice editor summary rail.
 */
export function getInvoiceEditorChecklist({
  title,
  itemCount,
  paymentScheduleIssueMessage,
}: {
  title: string
  itemCount: number
  paymentScheduleIssueMessage?: string
}): InvoiceEditorChecklistItem[] {
  return [
    {
      id: 'title',
      section: 'details',
      label: title.trim() ? 'Title added' : 'Add a title',
      satisfied: !!title.trim(),
    },
    {
      id: 'contents',
      section: 'items',
      label: pluralize(itemCount, 'line item'),
      satisfied: itemCount > 0,
    },
    {
      id: 'schedule',
      section: 'payment',
      label: paymentScheduleIssueMessage || 'Schedule covers 100% of total',
      satisfied: !paymentScheduleIssueMessage,
    },
  ]
}
